import uuid from 'uuid/v1'
import * as msgConstants from '../../constants/General'
import { updateTab , addActionInTab} from "../Tabs"

export const addMsgbox = (parentId = null) => {
  return (dispatch, getState) => {
    let { tabs, currentTab } = getState()
    let tab = tabs[currentTab]
    let action = {
      id : uuid(),
      type : msgConstants.MESSAGE_BOX,
      parentId : parentId,
      label : 'Message Box',
      key : "msgbox",
      allowNesting : false,
      message: "",
      timeout:0,
      description :  "",
      status:false,
      breakpint:false

    }
    tab = addActionInTab(tab, action, parentId)
    dispatch(updateTab(tab))
  }
}

export const editMsgbox = (payload) => {
  return (dispatch, getState) => {
    let { tabs, currentTab } = getState()
    let tab = tabs[currentTab]
    let { currentAction } = tab
    let msgboxAction = tab["actions"][currentAction]
    let temp = {
      ...msgboxAction,
      ...payload
    }
    temp.message!=""?temp.status=true:temp.status=false
    let message = temp?temp.message.replace(/,/g, ''):""
    let instruction = `vision MsgBox, ,Techforce, ${message},${temp.timeout} `
    tab["actions"][currentAction] = {
      ...temp,
      instruction : instruction,
      description : message
    }
    dispatch(updateTab(tab))
  }
}
